export default __webpack_public_path__ + "static/media/Supplier-List-min.0d243e25.png";